import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { TransactionTypeModel } from "@tggstore/Store/State/Custom/TransactionType";

type HandlerType = Handler<{
    transactionType: TransactionTypeModel | undefined;
}>;

export const DispatchTransactionType: HandlerType = ({ dispatch, parameter: { transactionType } }) => {
    dispatch({
        type: "Custom/CheckoutReviewAndSubmit/TransactionType",
        transactionType,
    } as any);
};

export const chain = [DispatchTransactionType];

const setTransactionType = createHandlerChainRunner(chain, "SetTransactionType");
export default setTransactionType;
